import { useState, useEffect } from 'react';

export const useScreenSize = () => {
  const [screenSize, setScreenSize] = useState<
    'sm' | 'md' | 'lg' | ''
  >('');

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 1024) {
        setScreenSize('sm');
      } else if (
        window.innerWidth > 1024 &&
        window.innerWidth <= 1440
      ) {
        setScreenSize('md');
      } else if (window.innerWidth > 1440) {
        setScreenSize('lg');
      }
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () =>
      window.removeEventListener('resize', handleResize);
  }, []);

  return screenSize;
};
